import DataFilter from '@/General/Tables/DataFilter.vue'
import FilterManager from '@/General/Tables/FilterManager.js'
import { TABLE_PER_PAGE_GETTER } from '@/Modules/Base/SettingModule.js'

export default {
  components: { DataFilter },

  props: {
    fetchCallback: {
      type: Function,
      default: () => { },
    },
    tableKey: String,
    model: {},
    hasRowActions: {
      type: Boolean,
      default: false,
    },
    id: String,
    filters: {
      type: Array,
      default: () => {
        return []
      },
    },
    inlineFilters: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    hasFilters: {
      type: Boolean,
      default: false,
    },
    selectable: {
      type: Boolean | Function,
      default: false,
    },
  },

  data() {
    return {
      showFilters: false,
      globalSearch: '',
      activeFilters: '',
      path: '',
      perPageSelectValues: [
        { label: 25, value: 25 },
        { label: 50, value: 50 },
        { label: 100, value: 100 },
        { label: 200, value: 200 },
      ],
      parameters: {
        per_page: this.$store.getters['SettingModule/' + TABLE_PER_PAGE_GETTER],
        page: 1,
        sort: this.defaultSort,
        q: '',
      },
      meta: {
        currentPage: 1,
        from: 1,
        lastPage: 1,
        perPage: this.$store.getters['SettingModule/' + TABLE_PER_PAGE_GETTER],
        to: 10,
        total: 0,
      },
      currentPage: 1,
      tableData: null,
      lodash: _,
      loading: false,
      selectedRows: [],
    }
  },

  computed: {
    computedTableData() {
      if (this.mutateData) {
        return this.mutateData(this.tableData)
      }

      return this.tableData
    },

    totalRecords() {
      if (this.mutateData && _.isArray(this.computedTableData)) {
        return this.computedTableData.length
      }

      return this.meta.total
    },
  },

  created() {
    this.debouncedSearch = _.debounce(this.refreshTable, 300)

    this.$watch('parameters.q', function () {
      this.parameters.page = 1
      this.globalSearch = this.parameters.q
      this.debouncedSearch()
    })

    this.$watch('selectedRows', function () {
      this.$emit('rowSelected', this.selectedRows)
    })

    this.filterTable()
  },

  methods: {
    changePage(event, page) {
      this.parameters.page = page

      this.refreshTable()
    },

    search() {
      return this.globalSearch
    },

    resetFilters() {
      this.$emit('filterResetCalled')
      this.globalSearch = ''
    },

    refreshTableWithPath(path) {
      if (path == undefined) {
        path = ''
      }
      this.path = '?&path=' + encodeURIComponent(path)
      this.refreshTable()
    },

    refreshTable() {
      this.loading = true

      this.fetchCallback &&
        this.fetchCallback({
          parameters: this.parameters,
          filters: this.activeFilters + this.path,
        })
          .then((response) => {
            if (response.data.meta) {
              const restMetaItems = {}

              Object.keys(response.data.meta).forEach((key) => {
                _.set(
                  restMetaItems,
                  _.camelCase(key),
                  _.get(response.data.meta, key)
                )
              })

              this.meta = {
                ...restMetaItems,
                currentPage: response.data.meta.current_page,
                from: response.data.meta.from,
                lastPage: response.data.meta.last_page,
                perPage: response.data.meta.per_page,
                to: response.data.meta.to,
                total: response.data.meta.total,
              }
            }

            if (response.data.tabCounts) {
              this.$emit('tabCountsUpdateCalled', response.data.tabCounts)
            }

            if (response.data.breadcrumbs) {
              this.$emit('breadcrumbsUpdateCalled', response.data.breadcrumbs)
            }

            this.tableData = _.map(
              response.data.data,
              (item) => new this.model(item)
            )
            this.currentPage = response.data.meta?.current_page

            if (this.selectable) {
              this.clearSelected()
            }

            this.$emit('tableDataLoaded', this.tableData)
          })
          .finally(() => {
            this.loading = false
          })
    },

    filterTable() {
      this.activeFilters = FilterManager.parse(this.filters)
      this.parameters.q = this.search()
      this.parameters.page = 1
      this.refreshTable()
    },

    changePerPage(perPage) {
      this.parameters.per_page = perPage
      this.refreshTable()
    },

    clearFilters() {
      this.resetFilters()
      this.filterTable()
    },

    selectAllRows() {
      this.selectedRows = [...this.tableData]
    },

    clearSelected() {
      this.selectedRows = []
    },

    selectRow(index) {
      const newRow = this.tableData[index]
      if (
        this.selectedRows.findIndex((item) => _.isEqual(item, newRow)) === -1
      ) {
        this.selectedRows.push(newRow)
      }
    },

    unselectRow(index) {
      const newRow = this.tableData[index]
      const rowIndex = this.selectedRows.findIndex((item) =>
        _.isEqual(item, newRow)
      )
      if (rowIndex !== -1) {
        this.selectedRows.splice(rowIndex, 1)
      }
    },

    isRowSelected(item) {
      if (this.selectedRows && item) {
        return this.selectedRows.findIndex((row) => _.isEqual(row, item)) !== -1
      }
      return false
    },

    expandTableRows(key = 'rowGroup') {
      if (_.isArray(this.tableData)) {
        this.tableData = this.tableData.map((row) => {
          if (_.isObject(row[key])) {
            _.set(row, `${key}.visible`, true)
            return row
          }
          return row
        })
      }
    },

    collapseTableRows(key = 'rowGroup') {
      if (!_.isArray(this.tableData)) {
        return
      }
      this.tableData = this.tableData.map((row) => {
        if (_.isObject(row[key])) {
          _.set(row, `${key}.visible`, false)
          return row
        }
        return row
      })
    },
  },
}
